var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Seite exportieren"),
      confirmText: this.$gettext("Erstellen"),
      confirmClass: "accept",
      closeText: this.$gettext("Schließen"),
      closeClass: "cancel",
      height: "350",
    },
    on: {
      close: function close($event) {
        return _vm.showElementExportDialog(false)
      },
      confirm: _vm.exportStructuralElementAction,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.exportRunning,
                    expression: "!exportRunning",
                  },
                ],
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$gettextInterpolate(
                        _vm.$gettext(
                          'Hiermit exportieren Sie die Seite "%{ pageTitle }" als ZIP-Datei.'
                        ),
                        {
                          pageTitle: _vm.structuralElement.attributes.title,
                        }
                      )
                    ) +
                    "\n            "
                ),
                _c(
                  "div",
                  {
                    staticClass: "cw-element-export",
                  },
                  [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.exportChildren,
                            expression: "exportChildren",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                        },
                        domProps: {
                          checked: Array.isArray(_vm.exportChildren)
                            ? _vm._i(_vm.exportChildren, null) > -1
                            : _vm.exportChildren,
                        },
                        on: {
                          change: function change($event) {
                            var $$a = _vm.exportChildren,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.exportChildren = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.exportChildren = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.exportChildren = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Unterseiten exportieren")) +
                          "\n                "
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("courseware-companion-box", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.exportRunning,
                  expression: "exportRunning",
                },
              ],
              attrs: {
                msgCompanion: _vm.$gettext(
                  "Export läuft, bitte haben sie einen Moment Geduld..."
                ),
                mood: "pointing",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.exportRunning,
                    expression: "exportRunning",
                  },
                ],
                staticClass: "cw-import-zip",
              },
              [
                _c("header", [_vm._v(_vm._s(_vm.exportState) + ":")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "progress-bar-wrapper",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "progress-bar",
                        style: {
                          width: _vm.exportProgress + "%",
                        },
                        attrs: {
                          role: "progressbar",
                          "aria-valuenow": _vm.exportProgress,
                          "aria-valuemin": "0",
                          "aria-valuemax": "100",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.exportProgress) +
                            "%\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }